module.exports = __webpack_public_path__ + "img/logo-igi.801405e.png";